import React from 'react';
import { Form, FormProps, FormRenderProps } from 'react-final-form';
import { Box, Stack } from '@mui/material';

import { Button, Typography } from '@occc/ui-design-system';
import { Select, TextField } from '@occc-app/design-system';

import { Location_Status, LocationFilterFormValues } from './LocationsList/types';

export type SiteManagementFilterFormProps = {
  onSubmit: FormProps<LocationFilterFormValues>['onSubmit'];
  onReset: () => void;
  initialValues: Partial<LocationFilterFormValues>;
};

const statusSelectOptions = [
  { label: 'All', value: Location_Status.All },
  { label: 'Active', value: Location_Status.Active },
  { label: 'Deleted', value: Location_Status.Deleted },
];

export const SiteManagementFilterForm = ({
  onSubmit,
  onReset,
  initialValues,
}: SiteManagementFilterFormProps) => {
  const renderForm: FormRenderProps<LocationFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit, form }: FormRenderProps<LocationFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onReset();
      };

      return (
        <Stack component='form' px={3} py={3} spacing={3} onSubmit={handleSubmit}>
          <Typography paragraph>Filter Locations</Typography>
          <TextField name='siteId' label='Site ID' />
          <Select name='status' label='Status' data={statusSelectOptions} />
          <TextField name='address' label='Address' />

          <Box display='flex' justifyContent='flex-end' gap={1}>
            <Button size='large' color='primary' onClick={reset}>
              reset
            </Button>
            <Button type='submit' size='large' color='primary' variant='contained'>
              apply
            </Button>
          </Box>
        </Stack>
      );
    },
    [onReset],
  );
  return (
    <Form<LocationFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
    />
  );
};
